<template>
  <span
    class="workbench-cat-logo"
    role="img"
    aria-label="AIMason 猫"
    :style="logoStyle"
  />
</template>

<script>
export default {
  name: 'WorkbenchCatLogo',
  props: {
    size: { type: [Number, String], default: 120 },
    color: { type: String, default: 'var(--awb-ink)' },
    // 保留旧调用参数兼容；猫头镂空直接透出页面背景，不再绘制身体或彩色胸标。
    paper: { type: String, default: 'var(--awb-bg)' },
    eyeColor: { type: String, default: '' },
    gradient: { type: Boolean, default: false }
  },
  computed: {
    dimension() { return typeof this.size === 'number' ? `${this.size}px` : this.size },
    logoStyle() {
      return { width: this.dimension, height: this.dimension, color: this.color,
        backgroundImage: this.gradient
          ? `linear-gradient(145deg, color-mix(in srgb, ${this.color} 48%, var(--awb-surface)), ${this.color} 48%, color-mix(in srgb, ${this.color} 72%, var(--awb-ink)))`
          : 'none',
        '--cat-mark': `url("${this.markUrl}")` }
    },
    markUrl() { return `${process.env.BASE_URL}brand/cat-mark.png` }
  }
}
</script>

<style scoped>
.workbench-cat-logo {
  display: inline-block;
  flex: 0 0 auto;
  vertical-align: middle;
  background-color: currentColor;
  -webkit-mask: var(--cat-mark) center / contain no-repeat;
  mask: var(--cat-mark) center / contain no-repeat;
}
</style>
